module.exports = __webpack_public_path__ + "img/1.62ac0e2e.jpg";